import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { GridFilterCellProps } from "@progress/kendo-react-grid";

interface DropdownFilterCellProps extends GridFilterCellProps {
    defaultItem: string;
    textField: string;
    data: any[];
}

export const DropdownFilterCell = (props: DropdownFilterCellProps) => {
    let hasValue: any = (value: any) => Boolean(value && value !== props.defaultItem);

    const onChange = (event: DropDownListChangeEvent) => {
        hasValue = hasValue(event.target.value);
        props.onChange({
            value: hasValue ? event.target.value.id : "",
            operator: hasValue ? "eq" : "",
            syntheticEvent: event.syntheticEvent,
        });
    };

    const value = props.value ? props.data.find(x => x.id === props.value) : props.defaultItem;

    return (
        <div className="k-filtercell">
            <DropDownList
                data={props.data}
                onChange={onChange}
                value={value}
                textField={props.textField}
                dataItemKey={"id"}
                defaultItem={props.defaultItem}
            />
        </div>
    );
};